// @module Jeske.AnnouncementBanner.ABModule
define('Jeske.AnnouncementBanner.ABModule.View'
,	[
		'jeske_announcementbanner_abmodule.tpl'
	,	'Backbone'
	]
,	function (
		jeske_announcementbanner_abmodule_tpl
	,	Backbone
	)
{
	'use strict';

	// @class Jeske.AnnouncementBanner.ABModule.View @extends Backbone.View
	return Backbone.View.extend({

		template: jeske_announcementbanner_abmodule_tpl

	,	initialize: function (options) {
			this.container = options.container;

			if (this.container && this.container.getComponent) {
				this.environment = this.container.getComponent('Environment');
			}
		}

	,	events: {
			'click [data-action="close-announcement-banner"]': 'closeBanner'
		}

	,	closeBanner: function (event) {
			event.preventDefault();
			var self = this;

			this.$el.animate({
				opacity: 0,
				height: 0,
				paddingTop: 0,
				paddingBottom: 0,
				marginTop: 0,
				marginBottom: 0
			}, 300, function () {
				self.$el.css('display', 'none');
			});
		}

	,	bindings: {
		}

	,	childViews: {
		}

		//@method getContext @return Jeske.AnnouncementBanner.ABModule.View.Context
	,	getContext: function getContext()
		{
			var showBanner = this.environment.getConfig('announcementbanner.showbanner') || false;
			var bannerText = this.environment.getConfig('announcementbanner.bannertext') || '';
			var bannerColor = this.environment.getConfig('announcementbanner.bannercolor') || 'Jeske Blue';

			var colorClassMap = {
				'Jeske Blue': 'ab-banner--jeske-blue',
				'Red':        'ab-banner--red',
				'Orange':     'ab-banner--orange',
				'Green':      'ab-banner--green'
			};

			var bannerColorClass = colorClassMap[bannerColor] || 'ab-banner--jeske-blue';

			return {
				showBanner:      showBanner,
				bannerText:      bannerText,
				bannerColorClass: bannerColorClass
			};
		}
	});
});
